import axios from "axios";
import CryptoJS from 'crypto-js'

const customAxios = axios.create();
// axios.defaults.withCredentials = true;
// customAxios.interceptors.request.use(async config=>{
//     if (config.data) {
//         const hashData = await CryptoJS.HmacMD5(JSON.stringify(config.data), '$2a$10$uyM6jw8ZEdkFbDvWJ7EIyO')
//         config.headers.Authorization =  hashData
//     }
//     if (config.url.includes('?')) {
//         let par = config.url.slice(config.url.indexOf('?')+1).split("&").map(item=>item.split("=")[1]).join("")
//         const hashParams = await CryptoJS.HmacMD5(par, '$2a$10$uyM6jw8ZEdkFbDvWJ7EIyO')
//         config.headers.Authorization = hashParams
//     }
//   return config;
// })

export default customAxios